'use client'

import React, { useCallback } from 'react'
import { useRouter } from 'next/navigation'
import { useTranslations } from 'next-intl'

import useRedirectToHome from '@/src/hooks/navigation/useRedirectToHome'

import AppTitleBar from './appTitleBar'

interface AppTitleBarWrapperProps {
    title: string
    /** The flow's entry page in the app: back closes the WebView rather than stepping through history. */
    isRoot?: boolean
}

const AppTitleBarWrapper: React.FC<AppTitleBarWrapperProps> = ({ title, isRoot = false }) => {
    const t = useTranslations('holidaysPage')
    const router = useRouter()
    const closeWebView = useRedirectToHome()

    const handleBack = useCallback(() => {
        // A page the WebView opened directly has nothing behind it, so back hands control to the app.
        if (isRoot || window.history.length <= 1) {
            void closeWebView({})
            return
        }
        router.back()
    }, [isRoot, closeWebView, router])

    return <AppTitleBar title={title} backLabel={t('back')} onBack={handleBack} />
}

export { AppTitleBarWrapper }
export default AppTitleBarWrapper
